import Vue from 'vue'
import VueI18n from 'vue-i18n'
import locales from '@/locales'
import { debounce } from '@/utils/helpers/helpFunctions'

Vue.use(VueI18n)

// const language = window.navigator ? window.navigator.language.slice(0, 2) : 'en'
const language = 'ru'

const getLocaleObject = () => {
  if (document.documentElement.offsetWidth <= 450) {
    i18n.setLocaleMessage(language, require(`./../locales/mobile/${language}`).default)
  } else {
    i18n.setLocaleMessage(language, require(`./../locales/desktop/${language}`).default)
  }
}

let i18n = new VueI18n({
  locale: process.env.VUE_APP_I18N_LOCALE || language,
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || language,
  messages: locales,
  silentTranslationWarn: true
})

window.addEventListener('resize', (e) => {
  debounce(getLocaleObject, 200)
})

getLocaleObject()

export default i18n
